/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FailureCreatorTypes {
    Other = 'Other',
    Contractor = 'Contractor',
    Repairman = 'Repairman',
    Council = 'Council',
    CallCenter = 'CallCenter',
    InternetNotification = 'InternetNotification'
}

export function FailureCreatorTypesFromJSON(json: any): FailureCreatorTypes {
    return FailureCreatorTypesFromJSONTyped(json, false);
}

export function FailureCreatorTypesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailureCreatorTypes {
    return json as FailureCreatorTypes;
}

export function FailureCreatorTypesToJSON(value?: FailureCreatorTypes | null): any {
    return value as any;
}

